"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _immutable = require("immutable");

var _LocalInteractionIdentifier = require("./LocalInteractionIdentifier");

/*
  Represents a local version of the interaction in the form of key/values to persist in session storage
*/
var LocalInteraction =
/*#__PURE__*/
function () {
  function LocalInteraction(interactionType, objectType, subjectId, localSettings) {
    var storage = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : localStorage;
    (0, _classCallCheck2.default)(this, LocalInteraction);
    this.setId = this.setId.bind(this);
    this.localSettings = localSettings;
    this.storage = storage;
    this.restored = false;
    this.data = (0, _immutable.Map)();
    this.key = (0, _LocalInteractionIdentifier.generateKey)(interactionType);
    this.setId(interactionType, objectType, subjectId);

    if (this.isRestorable()) {
      this.restore();
    } else {
      this.reset();
    }
  }

  (0, _createClass2.default)(LocalInteraction, [{
    key: "setId",
    value: function setId(interactionType, objectType, subjectId) {
      this.set(_LocalInteractionIdentifier.ID, (0, _LocalInteractionIdentifier.toId)(interactionType, objectType, subjectId));
      return this;
    }
  }, {
    key: "setType",
    value: function setType(type) {
      this.set(_LocalInteractionIdentifier.TYPE, type);
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this.data = this.data.set(key, value);
      return this;
    }
  }, {
    key: "get",
    value: function get(key, fallbackValue) {
      return this.data.get(key, fallbackValue);
    }
  }, {
    key: "isRestored",
    value: function isRestored() {
      return this.restored;
    }
  }, {
    key: "isRestorable",
    value: function isRestorable() {
      return (0, _LocalInteractionIdentifier.isLocalIdEqualTo)(this.key, this.get(_LocalInteractionIdentifier.ID), this.localSettings.getFrom, this.storage);
    }
  }, {
    key: "restore",
    value: function restore() {
      this.data = (0, _immutable.fromJS)(this.localSettings.getFrom(this.storage, this.key)).update('associations', function (innerMap) {
        return innerMap ? innerMap.map(function (aList) {
          return (0, _immutable.Set)(aList);
        }) : innerMap;
      });
      this.restored = true;
      return this;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.data = (0, _immutable.Map)({
        id: this.data.get(_LocalInteractionIdentifier.ID)
      });
      this.restored = false;
      this.localSettings.deleteFrom(this.storage, this.key);
      return this;
    }
  }, {
    key: "save",
    value: function save() {
      this.localSettings.setFrom(this.storage, this.key, this.data);
      return this;
    }
  }]);
  return LocalInteraction;
}();

exports.default = LocalInteraction;
module.exports = exports.default;